// @flow
import { PRODUCT_INFORMATION_SUMMARY } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { buildProductArgs } from 'Utils/graphql';
import { LINE_PRODUCT_INFORMATION_SUMMARY } from 'Utils/request/requestDictionary';

type CMSProps = {
  downloadLabel: string,
  resortId: string,
  text: string,
};

type GQLProps = {
  resort: {
    factSheetUrl: string,
  },
};

export const productInformationSummaryResolver = {
  name: PRODUCT_INFORMATION_SUMMARY,
  resolve(
    appContext: AppContext,
    props: CMSProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId: productId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(productId, urlParams);
    const query = `query {resort(${productArgs}) {factSheetUrl}}`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_INFORMATION_SUMMARY,
      strictErrors: false,
    });
  },
};
